import { render, staticRenderFns } from "./ContractChangeAssets.vue?vue&type=template&id=0f58dcfc&scoped=true"
import script from "./ContractChangeAssets.vue?vue&type=script&lang=js"
export * from "./ContractChangeAssets.vue?vue&type=script&lang=js"
import style0 from "./ContractChangeAssets.vue?vue&type=style&index=0&id=0f58dcfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f58dcfc",
  null
  
)

export default component.exports